export function getNoticeAgreement({ jwt }) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/pd/getNoticeAgreements`, {
    method: "GET",
    mode: "cors",
    headers: { Authorization: `Bearer ${jwt}` },
  })
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
      throw response
    })
    .then((payload) => ({ payload }))
    .catch((error) => ({ error }))
}

export function putNoticeAgreement({ params, jwt }) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/pd/putNoticeAgreements`, {
    method: "PUT",
    body: JSON.stringify({
      telephone_notice_agree: String(params.telephoneNoticeAgree),
      directmailflg: String(params.dmNoticeAgree),
    }),
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
      throw response
    })
    .then((payload) => ({ payload }))
    .catch((error) => ({ error }))
}
